import React, { useEffect, useState } from 'react'
import { DataTable, Table, Button } from '@arnsbogroup/react-voicearchive'
import {Timestamp, Span} from 'components/datatable'
import { useIntl } from 'react-intl'
import messages from "./messages";
import useApi from 'hooks/useApi'


const Tasks = ( { supplier, history, taskState, ...props } ) => {
    if (!supplier) {
        return null
    }

    const { formatMessage } = useIntl()
    const [page, setPage] = useState(1)
    const [data,,, refetch] = useApi(`/supplierdisplay/${taskState}.json?supplierId=${supplier.uid}&page=${page}`)

    useEffect(() => {
        refetch({
            url: `/supplierdisplay/${taskState}.json?supplierId=${supplier.uid}&page=${page}`
          })
    }, [page, taskState])

    if (!data) {
        return null
    }

    return (
        <div className="w-full overflow-x-scroll">
            <DataTable
                components={{
                    Tr: ({ childProps = {}, ...innerProps }) => {
                        return (
                            <Table.Tr onClick={childProps.uid ? () => history.push(`/task/${childProps.uid}?currentOrderId=${childProps.orderid}&currentTaskId=${childProps.uid}&v=${+Date.now()}`) : undefined}
                                {...innerProps }
                            />
                        )
                    },
                    Td: ({ childProps = {}, ...props }) => (
                        <Table.Td
                            {...props }
                        />
                    )
                }}
                head={{
                    title: { label: formatMessage(messages.title) },
                    deadline: { label: formatMessage(messages.deadline) },
                    cost: { label: formatMessage(messages.cost) },
                    price: { label: formatMessage(messages.price) },
                    uid: { label: formatMessage(messages.taskId) },
                    orderid: { label: formatMessage(messages.orderId) },
                    wordcount: { label: formatMessage(messages.wordCount) },
                    customer: { label: formatMessage(messages.customer) },
                    contact: { label: formatMessage(messages.contact) },
                    partner: { label: formatMessage(messages.partner) },
                    medias: { label: formatMessage(messages.media) },
                }}
                body={{
                    title: Span,
                    deadline: Timestamp,
                    cost: ({ cost, costcurrency }) => <Span>{ cost } {costcurrency}</Span>,
                    price: ({ price, pricecurrency }) => <Span>{ price } {pricecurrency}</Span>,
                    uid: Span,
                    orderid: Span,
                    wordcount: Span,
                    customer: Span,
                    contact: Span,
                    partner: Span,
                    medias: Span,
                }}
                entries={!!data.tasks ? data.tasks : []}
                indicators={[]}
            />
            <div className="space-x-2 px-4">
                <Button
                    onClick={() => page > 1 ? setPage(page - 1) : undefined}
                    variant="inline"
                    size="sm"
                    disabled={page == 1}
                >
                    {formatMessage(messages.prev)}
                </Button>

                <Button
                    onClick={() => setPage(page + 1)}
                    variant="inline"
                    size="sm"
                    disabled={page >= data.lastPage}
                >
                    {formatMessage(messages.next)}
                </Button>
            </div>
        </div>
    )
}

export default Tasks
